import axios from 'axios'
import NProgress from 'nprogress'

import { getSSORedirectUrl } from '../helpers/ssoHelper'


axios.interceptors.request.use(config => {
  NProgress.start()
  return config
})

axios.interceptors.response.use(response => {
  NProgress.done()
  return response
})

const baseDomain = process.env.VUE_APP_BASEDOMAIN
const configDomain = process.env.VUE_APP_CONFIGDOMAIN
const baseEnv = process.env.VUE_APP_BASEENV
const securityUrl = process.env.VUE_APP_FANBASESECURITY
const fanPageUrl = process.env.VUE_APP_FANPAGEDOMAIN
const baseUrl = `${baseDomain}/${baseEnv}`
const baseSecurityUrl = `${securityUrl}/${baseEnv}`
const baseFanPageUrl = `${fanPageUrl}/${baseEnv}`

export class loginFB {
  constructor() {}
  getLoginConf(domain, subdomain) {
    return new Promise(resolve => {
      const url = `${configDomain}/sys/login/${domain}/${subdomain}/login-setup.json`
      axios.get(url).then(
        response => {
          resolve(response.data)
        },
        () => {
          window.location.href = 'http://fanbase.com.br/'
        },
      )
    })
  }
  createAccount(data) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseSecurityUrl}/account`
      axios.post(cmd, data).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            reject(r.data.header.msg)
          }

          if (r.data.header.codigo == 0) {
            resolve(r.data.header.msg)
          }
        },
        err => {
          reject(err)
        },
      )
    })
  }
  newAccountPassword(data) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseSecurityUrl}/account/NewPassword`
      axios.post(cmd, data).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            reject(r.data.header.msg)
          }
        },
        err => {
          reject(err)
        },
      )
    })
  }
  recoverPwd(data) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseSecurityUrl}/pwd`
      axios.post(cmd, data).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            reject(r.data.header.msg)
          }
        },
        err => {
          reject(err)
        },
      )
    })
  }
  login(payload, bySession = false) {
    return new Promise((resolve, reject) => {
      let cmd = bySession ? `${baseSecurityUrl}/login/bysession` : `${baseSecurityUrl}/login`
      if (payload.systemId == 100 && !bySession) {
        let mode = baseSecurityUrl.includes('fantest')
          ? 'https://dashv2.fantest.com.br'
          : 'https://dash.fanbox.app.br'
        cmd = `${baseSecurityUrl}/authorize?response_type=code&scope=openid&client_id=fanbox2&redirect_uri=${mode}`
      }
      axios.post(cmd, payload).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            localStorage.removeItem('session')
            location.reload()
            reject('Confirme seus dados. ' + r.data.header.msg)
          }
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }
  Authorize(loginInfo, oauthData, bySession = false, config = null) {
    return new Promise((resolve, reject) => {
      const dontUseSso = (!config || !config.sso || !config.sso.clientId || !config.sso.redirectUrl) || Object.keys(oauthData).length
      let url = bySession
        ? `${baseSecurityUrl}/authorize/bysession`
         :  dontUseSso
         ? `${baseSecurityUrl}/authorize`
         : `${baseSecurityUrl}/${getSSORedirectUrl(config)}` 
      if (dontUseSso) {
        let queryString = new URLSearchParams(oauthData).toString()
        url += `?${queryString}`
      }
      axios.post(url, loginInfo).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else if (r.data.header.codigo == 3) {
            window.location.href = r.data.data
          } else {
            reject('Confirme seus dados. ' + r.data.header.msg)
          }
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }
  CheckTK(tk) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseUrl}/checkLogin`
      const header = { headers: { Authorization: `Bearer ${tk}` } }

      axios.post(cmd, null, header).then(
        r => {
          if (r.data.header.codigo === 1) resolve(r.data)
          else reject(r.data.header.msg)
        },
        () => {
          reject()
        },
      )
    })
  }
  validateAuthorizeRequest(oauthData) {
    return new Promise((resolve, reject) => {
      let url = `${baseSecurityUrl}/authorize/validateRequest`
      let queryString = new URLSearchParams(oauthData).toString()
      url += `?${queryString}`
      axios.get(url).then(
        r => {
          if (r.data.header.codigo == 3) {
            alert(JSON.stringify(oauthData), 'header3')
            window.location.href = r.data.data
          } else if (r.data.header.codigo == 0) {
            reject(r.data.header.msg)
          } else resolve('ok')
        },
        err => {
          alert(JSON.stringify(oauthData), 'err')
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }
  GetRedirectUrl(sessionToken, mode) {
    return new Promise((resolve, reject) => {
      let url = `${baseSecurityUrl}/session/redirection/${sessionToken}`
      axios.get(url).then(
        r => {
          if (r.data.header.codigo == 1) {
            if (mode && mode == true) {
              let url = new URL(r.data.data)
              url.searchParams.set('mode', 'visitor')
              r.data.data = url.toString()
              window.location.href = r.data.data
            } else {
              window.location.href = r.data.data
            }
          } else if (r.data.header.codigo == 0) {
            reject(r.data.header.msg)
          } else resolve('ok')
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }
  GetCountries() {
    return new Promise((resolve, reject) => {
      let url = `${baseSecurityUrl}/country`
      axios.get(url).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            reject(r.data.header.msg)
          }
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }
  CheckSessionValidity(sessionToken) {
    return new Promise((resolve, reject) => {
      let url = `${baseSecurityUrl}/session/checkvalidity/${sessionToken}`
      axios.get(url).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else if (r.data.header.codigo == 0) {
            resolve(false)
          } else resolve(false)
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }
  getFileContentLoc(domain, subdomain) {
    return new Promise((resolve, reject) => {
      const url = `${configDomain}/sys/login/${domain}/${subdomain}/termos.html`
      axios.get(url).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(error)
        },
      )
    })
  }
  checkLogin(loginId, ownerId, clientName) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseSecurityUrl}/Account/v2/check?client=${clientName}&ownerId=${ownerId}`
      const userCPF = loginId.replace(/\D/g, '')
      const payload = { userLogin: userCPF, NumberType: 1 }
      axios.post(cmd, payload).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            reject('Confirme seus dados. ' + r.data.header.msg)
          }
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }
  sendEmailCodeToConfirm(email, ownerId, name) {
    return new Promise((resolve, reject) => {
      const payload = {
        OwnerId: ownerId,
        Identity: 0,
        NumberType: 4,
        Number: email,
      }
      const url = `${baseFanPageUrl}/numberconfirmation/login/${name}`
      axios.post(url, payload).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
      )
    })
  }
  checkEmailCodeToConfirm(code, email, name) {
    return new Promise((resolve, reject) => {
      const url = `${baseSecurityUrl}/numberconfirmation/check/login/${name}`
      var payload = {
        Email: email,
        Code: code,
      }
      axios.post(url, payload).then(
        response => {
          let codesuccess = response.data.header.codigo
          resolve(codesuccess)
        },
        error => {
          reject(error)
        },
      )
    })
  }
  get2FAData(clientId, sessionToken) {
    return new Promise((resolve, reject) => {
      const url = `${baseSecurityUrl}/login/verification2FA/v2/${clientId}/${sessionToken}`
      axios.get(url).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(error)
        },
      )
    })
  }
  validate2FACode(sessionToken, code) {
    return new Promise((resolve, reject) => {
      const url = `${baseSecurityUrl}/session/validate2FACode/${sessionToken}/${code}`
      axios.get(url).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(error)
        },
      )
    })
  }
  resendVerificationCode(sessionToken, clientId, resendOption) {
    return new Promise((resolve, reject) => {
      let url = `${baseSecurityUrl}/session/verificationCodeResend/${clientId}/${sessionToken}`
      if (resendOption) {
        url += `/${resendOption}`
      }
      axios.get(url).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(error)
        },
      )
    })
  }
  updateFacialBiometry(payload) {
    return new Promise((resolve, reject) => {
      const url = `${baseUrl}/FanData/UpdateFacialBiometryV2`
      axios.post(url, payload).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(error)
        },
      )
    })
  }
  getAttributes(ownerId) {
    return new Promise((resolve, reject) => {
      const url = `${fanPageUrl}/api/Attribute/attributes/${ownerId}`
      axios
        .get(url)
        .then(response => {
          if (response.data.header.codigo === 1) {
            resolve(response.data.data)
          } else {
            reject(response.data.header.msg)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  checkFacialBiometry(identity, ownerId, systemId) {
    return new Promise((resolve, reject) => {
      const url = `${baseUrl}/FanData/CheckFacialBiometry/${identity}/${ownerId}/${systemId}`
      axios
        .get(url)
        .then(response => {
          if (response.data.header.codigo === 1) {
            resolve(response.data.data)
          } else {
            reject(response.data.header.msg)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  externalSSO(payload) {
    return new Promise((resolve, reject) => {
      const url = `${baseSecurityUrl}/login/externalSSO`
      axios.post(url, payload).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            reject('Confirme seus dados. ' + r.data.header.msg)
          }
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }
}
